import { Textarea, TextareaProps } from "@mantine/core";
import clsx from "clsx";
import React from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

export type ITTextAreaProps<T extends FieldValues> = UseControllerProps<T> &
  TextareaProps;

const TTextArea = <T extends FieldValues>(props: ITTextAreaProps<T>) => {
  const {
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    onChange,
    className,
    classNames,
    ...other
  } = props;

  const {
    field: { value, onChange: fieldChange, ...field },
    fieldState,
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
  });

  return (
    <>
      <Textarea
        classNames={{
          input: clsx(
            "h-full w-full border-b border-b-primary-500 bg-primary-50 px-4 py-4 text-sm text-black-900 placeholder-gray-500 focus:border-b-primary-900",
            fieldState.error?.message && "focus:!border focus:!border-red-500",
          ),
          error: clsx("text-red-500"),
          ...classNames,
        }}
        value={value}
        radius="xs"
        variant="unstyled"
        withErrorStyles
        resize="vertical"
        onChange={(e) => {
          fieldChange?.(e);
          onChange?.(e);
        }}
        {...other}
        {...field}
      />

      {fieldState.error?.message && (
        <span className="mt-1 text-sm leading-3 text-red-500">
          {fieldState.error?.message}
        </span>
      )}
    </>
  );
};

export default TTextArea;
